/**
 * Where the Felix chat panel keeps its messages in this browser (row 2acb58cf).
 *
 * The saved chat is per PERSON as well as per project. Keyed by project alone,
 * two people on one browser shared it -- measured 2026-10-15: Bob's earlier
 * lines went into Claire's FB-0067 ticket from this storage.
 */
const FELIX_STORAGE_KEY_PREFIX = "felix_chat_history";

export function getProjectStorageKey(userId: string | undefined, projectId?: string): string {
  const owner = `${FELIX_STORAGE_KEY_PREFIX}_u_${userId || "anon"}`;
  return projectId ? `${owner}_${projectId}` : owner;
}

/** Keys from before 2acb58cf held whoever used the browser last. They are
 *  deleted and never read: `felix_chat_history` and `felix_chat_history_<project>`. */
const LEGACY_HISTORY_KEY = new RegExp(`^${FELIX_STORAGE_KEY_PREFIX}(_[0-9a-f-]{36})?$`);

export function purgeLegacyChatHistory(): void {
  for (const store of [localStorage, sessionStorage]) {
    try {
      const stale: string[] = [];
      for (let i = 0; i < store.length; i++) {
        const k = store.key(i);
        if (k && LEGACY_HISTORY_KEY.test(k)) stale.push(k);
      }
      stale.forEach((k) => store.removeItem(k));
    } catch { /* storage unavailable */ }
  }
}

export function loadPersistedMessages<T>(userId: string | undefined, projectId?: string): T[] {
  try {
    const key = getProjectStorageKey(userId, projectId);
    const raw = localStorage.getItem(key) || sessionStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T[]) : [];
  } catch {
    return [];
  }
}
